const ScheduleIcon = ({ viewBox = "0 0 20 20", className = "hayley-h-5 hayley-w-5 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path d="M14.583 13.75V15.4167H16.2497" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
      <path
        d="M14.5837 19.5833C16.8848 19.5833 18.7503 17.7179 18.7503 15.4167C18.7503 13.1155 16.8848 11.25 14.5837 11.25C12.2825 11.25 10.417 13.1155 10.417 15.4167C10.417 17.7179 12.2825 19.5833 14.5837 19.5833Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path d="M7.91667 18.75H1.25V3.75H19.5833V9.58333" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M6.25 1.25V3.75" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M14.583 1.25V3.75" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M1.25 7.08301H19.5833" stroke="currentColor" strokeMiterlimit="10" />
    </svg>
  );
};

export default ScheduleIcon;
